var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkAgainPersonnelIcon = function SvgLinkAgainPersonnelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "link-again-personnel-icon_svg__a",
    width: "105.6%",
    height: "133.8%",
    x: "-2.8%",
    y: "-14%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "link-again-personnel-icon_svg__b",
    d: "M0 0h824v136H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-492-196H948v1540H-492z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -40)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#link-again-personnel-icon_svg__b",
    fill: "#000",
    filter: "url(#link-again-personnel-icon_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#link-again-personnel-icon_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.667,
    cy: 25.667,
    r: 25.667,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.667 28.583c7.525 0 13.728 5.51 14.583 12.61-4.02 3.064-9.083 4.89-14.583 4.89s-10.563-1.826-14.583-4.888c.854-7.102 7.057-12.612 14.583-12.612Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.667,
    cy: 20.417,
    r: 8.167,
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 46.667,
    r: 8.75,
    fill: "#F3F5F7",
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "m27.56 47.052-.024-.032-.012-.016a.58.58 0 0 1-.108-.392V42a.583.583 0 1 1 1.167 0v4.329l3.747 2.164a.583.583 0 1 1-.583 1.01l-4.012-2.317-.012-.006-.018-.01-.016-.01-.045-.031.061.04a.6.6 0 0 1-.11-.082l-.007-.008z"
  })))));
};
export default SvgLinkAgainPersonnelIcon;